// Minimal i18n without a dependency. Languages selected for the men's-
// health funnel: English (national), Spanish (Hispanic-American — second-
// largest segment), and Brazilian Portuguese (the second-largest GLP-1 /
// men's-health telehealth language globally and a meaningful US-Brazilian
// community in TX / FL / NJ). Arabic and German were dropped because they
// produced no meaningful conversion signal in early testing.
export const LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'es', label: 'Español', dir: 'ltr' },
  { code: 'pt', label: 'Português', dir: 'ltr' }
];

const strings = {
  en: {
    heroEyebrow: 'Concierge Men’s Health',
    heroTitle: 'A private conversation, not a form.',
    heroSub:
      'Pick the voice that speaks to who you are. Alfred calls you back within 60 seconds.',
    chooseVoice: 'Choose your voice',
    continue: 'Continue',
    back: 'Back',
    journeyTitle: 'Alfred will call within 60 seconds.',
    journeySub: 'Your first name and a number. Nothing else.',
    firstName: 'First name',
    firstNamePh: 'What should Alfred call you?',
    phone: 'Phone number',
    phonePh: '(555) 555-5555',
    language: 'Preferred language',
    consentLabel:
      'I agree to receive a call and texts from Alfred. Message and data rates may apply. Reply STOP to end.',
    callConsentLabel:
      'OK to call me at this number (including automated/AI calls) about my request.',
    textConsentLabel:
      'OK to text me at this number (msg/data rates may apply; reply STOP to opt out).',
    submit: 'Call me now',
    submitting: 'Connecting…',
    connectTitle: 'Alfred is calling you now.',
    connectSub:
      'Keep your phone close. He’ll introduce himself, listen, and walk with you.',
    connectMeta: 'If you miss the call, he’ll try again in a few minutes.',

    // Credibility section
    credibilityEyebrow: 'Trusted',
    credibilityTitle: 'Built for men who are done with the run-around.',
    trustPrivate: 'Private',
    trustPrivateBody:
      'Your conversation stays between you and Alfred. Your details never hit an advertiser.',
    trust247: '24/7 on call',
    trust247Body:
      'Alfred is on the line whenever you decide it’s time. No appointment. No waiting room.',
    trustLicensed: 'Licensed doctors',
    trustLicensedBody:
      'When a prescription makes sense, a board-certified provider in your state takes it from there.',
    regulatoryBlurb:
      'Alfred does not prescribe or diagnose. When the conversation calls for it, a licensed provider handles the medical intake and prescription in their own secure system. Prescriptions dispensed by a licensed U.S. pharmacy.',

    // Testimonials
    testimonialsTitle: 'From the men who called',
    testimonial1Name: 'Marcus, 42 — Houston, TX',
    testimonial1Text:
      'First call in 90 seconds. Script to my door in 48 hours. No calendar games, no waiting room.',
    testimonial2Name: 'Jordan, 38 — Chicago, IL',
    testimonial2Text:
      'No lectures, no “healthy lifestyle” playbook I already know. Straight to what would actually help.',
    testimonial3Name: 'Dave, 51 — Phoenix, AZ',
    testimonial3Text:
      'He actually listened. Whole thing took under ten minutes. Got me in front of a real doctor the next day.',

    // Programs / pricing
    plansEyebrow: 'Programs',
    plansTitle: 'Three programs. One bundle.',
    plansSub:
      'Pick what fits — ED, testosterone, or GLP-1 weight loss. Or get the Total bundle and have all three on hand. Monthly. Cancel anytime.',
    planCadence: 'month',
    planPerformanceName: 'Performance',
    planPerformanceTag: 'ED',
    planPerformanceBody:
      'FDA-approved generics for erectile dysfunction. Provider visit, prescription, and discreet shipping included.',
    planStrengthName: 'Strength',
    planStrengthTag: 'Testosterone',
    planStrengthBody:
      'Testosterone replacement therapy when medically appropriate. Biannual labs, provider visits, and medication included.',
    planResetName: 'Reset',
    planResetTag: 'GLP-1 Weight Loss',
    planResetBody:
      'Compounded semaglutide or tirzepatide for men who are ready. Provider visit, dose titration, and shipping included.',
    planTotalName: 'Total',
    planTotalTag: 'All Three',
    planTotalBody:
      'Performance + Strength + Reset together. Save about $160 a month vs subscribing separately.',
    plansFooter:
      'Membership covers unlimited concierge calls with Alfred. Medical visits and prescriptions are handled by board-certified providers in your state and billed at fair, transparent rates. We don\'t take insurance — many patients use HSA or FSA receipts.',

    // Membership (legacy keys — kept for any leftover references; new copy is plans*)
    membershipEyebrow: 'Programs',
    membershipTitle: 'Three programs. One bundle.',
    membershipSub:
      'Pick what fits — ED, testosterone, or GLP-1 weight loss. Or get the Total bundle.',
    membershipBullet1: 'Unlimited Alfred',
    membershipBullet1Body: 'Talk as often as you need. He picks up where you left off.',
    membershipBullet2: 'Real care, when warranted',
    membershipBullet2Body:
      'Board-certified providers handle the medical visit and prescription. Billed transparently, separately.',
    membershipBullet3: 'No commitment',
    membershipBullet3Body: 'Monthly. Cancel in one call. No retention pitch.',

    // Differentiation
    diffEyebrow: 'Why this',
    diffTitle: 'A relationship, not a checkout.',
    diffHims: 'Hims wants you to fill out a form.',
    diffHimsBody: 'We want you to talk.',
    diffRo: 'Ro sends you a script.',
    diffRoBody: 'We build a thread that knows you over time.',
    diffOthers: 'Other clinics disappear after the prescription.',
    diffOthersBody: 'Alfred follows up.',

    // About
    aboutEyebrow: 'Who built this',
    aboutTitle: 'Brian Southers, founder.',
    aboutBody:
      'AI specialist and UAV technologist. The last decade was teaching machines to respond to humans in real time — first in autonomous flight, then in conversational systems. This is the next thing.',

    // FAQ
    faqTitle: 'Questions men ask',
    faq1Q: 'What does the $99 cover?',
    faq1A:
      'Unlimited concierge calls with Alfred — anytime, day or night. Medical care, prescriptions, and pharmacy fulfillment are billed separately at fair, transparent rates by licensed providers and pharmacies.',
    faq2Q: 'Is Alfred a doctor?',
    faq2A:
      'No. Alfred is your concierge — he listens, organizes, and gets you to the right place. When the conversation calls for medical care, a board-certified provider in your state takes the visit and prescription from there.',
    faq3Q: 'Is my conversation private?',
    faq3A:
      'Yes. Conversations stay between you and Alfred. Your details are never sold, shared with advertisers, or used to retarget you.',
    faq4Q: 'How fast does Alfred call back?',
    faq4A: 'Within 60 seconds. Day or night, weekend or holiday. If you miss the call, he tries again in a few minutes.',
    faq5Q: 'Can I cancel anytime?',
    faq5A: 'Yes. Monthly subscription, no commitment, no retention pitch.',

    // Persona cards
    persona_tradesman_tagline: 'Hard work. Straight talk.',
    persona_tradesman_blurb:
      "For the man who works with his hands. No pitch, no fluff — just answers.",
    persona_tradesman_cta: "Let's talk now.",
    persona_executive_tagline: 'Sharp mind. Respects your time.',
    persona_executive_blurb:
      'For the man leading teams and families. Private, efficient, built around your schedule.',
    persona_executive_cta: "I've got a minute.",
    persona_professional_tagline: 'Engineer. Maker. Operator.',
    persona_professional_blurb:
      'For the man who thinks in systems. Curious, direct, no hype.',
    persona_professional_cta: "Let's dig in."
  },
  es: {
    heroEyebrow: 'Salud masculina personalizada',
    heroTitle: 'Una conversación privada, no un formulario.',
    heroSub:
      'Elige la voz que represente quién eres. Alfred te llama en 60 segundos.',
    chooseVoice: 'Elige tu voz',
    continue: 'Continuar',
    back: 'Atrás',
    journeyTitle: 'Alfred te llamará en 60 segundos.',
    journeySub: 'Solo necesitamos un número y un idioma. Nada más.',
    phone: 'Número de teléfono',
    phonePh: '(555) 555-5555',
    language: 'Idioma preferido',
    consentLabel:
      'Acepto recibir una llamada y mensajes de Alfred. Pueden aplicarse tarifas. Responde STOP para cancelar.',
    callConsentLabel:
      'Autorizo que me llamen a este número (incluidas llamadas automáticas/con IA) sobre mi solicitud.',
    textConsentLabel:
      'Autorizo que me envíen mensajes de texto a este número (pueden aplicarse tarifas de mensajes/datos; responde STOP para cancelar).',
    submit: 'Llámame ahora',
    submitting: 'Conectando…',
    connectTitle: 'Alfred te está llamando ahora.',
    connectSub:
      'Mantén tu teléfono cerca. Se presentará, escuchará y caminará contigo.',
    connectMeta: 'Si no contestas, volverá a intentarlo en unos minutos.',

    // Persona cards
    persona_tradesman_tagline: 'Trabajo duro. Sin rodeos.',
    persona_tradesman_blurb:
      'Para el hombre que trabaja con sus manos. Sin discursos, sin relleno — solo respuestas.',
    persona_tradesman_cta: 'Hablemos ahora.',
    persona_executive_tagline: 'Mente aguda. Respeta tu tiempo.',
    persona_executive_blurb:
      'Para el hombre que lidera equipos y familia. Privado, eficiente, hecho para tu agenda.',
    persona_executive_cta: 'Tengo un minuto.',
    persona_professional_tagline: 'Ingeniero. Creador. Operador.',
    persona_professional_blurb:
      'Para el hombre que piensa en sistemas. Curioso, directo, sin exageraciones.',
    persona_professional_cta: 'Vamos al grano.',

    // Programs / pricing
    plansEyebrow: 'Programas',
    plansTitle: 'Tres programas. Un paquete.',
    plansSub:
      'Elige lo que necesitas — disfunción eréctil, testosterona o pérdida de peso con GLP-1. O lleva el paquete Total. Mensual. Cancela cuando quieras.',
    planCadence: 'mes',
    planPerformanceName: 'Performance',
    planPerformanceTag: 'Disfunción Eréctil',
    planPerformanceBody:
      'Genéricos aprobados por la FDA para disfunción eréctil. Consulta médica, receta y envío discreto incluidos.',
    planStrengthName: 'Strength',
    planStrengthTag: 'Testosterona',
    planStrengthBody:
      'Terapia de reemplazo de testosterona cuando es médicamente apropiado. Análisis semestrales, consultas y medicación incluidos.',
    planResetName: 'Reset',
    planResetTag: 'GLP-1 Pérdida de Peso',
    planResetBody:
      'Semaglutida o tirzepatida compuesta para hombres listos para el cambio. Consulta, ajuste de dosis y envío incluidos.',
    planTotalName: 'Total',
    planTotalTag: 'Los Tres',
    planTotalBody:
      'Performance + Strength + Reset juntos. Ahorra alrededor de $160 al mes versus suscribirse por separado.',
    plansFooter:
      'La membresía cubre llamadas ilimitadas con Alfred. Las consultas médicas y recetas las manejan proveedores certificados en tu estado y se facturan a tarifas justas y transparentes. No aceptamos seguros — muchos pacientes usan recibos de HSA o FSA.'
  },
  pt: {
    heroEyebrow: 'Saúde masculina personalizada',
    heroTitle: 'Uma conversa privada, não um formulário.',
    heroSub:
      'Escolha a voz que combina com você. Alfred liga de volta em 60 segundos.',
    chooseVoice: 'Escolha sua voz',
    continue: 'Continuar',
    back: 'Voltar',
    journeyTitle: 'Alfred ligará em 60 segundos.',
    journeySub: 'Só precisamos do seu primeiro nome e do seu número.',
    firstName: 'Primeiro nome',
    firstNamePh: 'Como o Alfred deve te chamar?',
    phone: 'Número de telefone',
    phonePh: '(11) 99999-9999',
    language: 'Idioma preferido',
    consentLabel:
      'Aceito receber uma ligação e mensagens do Alfred. Podem ser aplicadas tarifas. Responda STOP para cancelar.',
    callConsentLabel:
      'Autorizo que me liguem para este número (incluindo ligações automáticas/com IA) sobre meu pedido.',
    textConsentLabel:
      'Autorizo que me enviem mensagens de texto para este número (podem ser aplicadas tarifas de mensagem/dados; responda STOP para cancelar).',
    submit: 'Me ligue agora',
    submitting: 'Conectando…',
    connectTitle: 'Alfred está te ligando agora.',
    connectSub:
      'Mantenha o telefone por perto. Ele vai se apresentar, ouvir e caminhar com você.',
    connectMeta: 'Se você perder a ligação, ele tenta de novo em alguns minutos.',

    // Persona cards
    persona_tradesman_tagline: 'Trabalho duro. Conversa reta.',
    persona_tradesman_blurb:
      'Para o homem que trabalha com as próprias mãos. Sem discurso, sem enrolação — só respostas.',
    persona_tradesman_cta: 'Vamos conversar agora.',
    persona_executive_tagline: 'Mente afiada. Respeita seu tempo.',
    persona_executive_blurb:
      'Para o homem que lidera equipes e família. Privado, eficiente, feito para sua agenda.',
    persona_executive_cta: 'Tenho um minuto.',
    persona_professional_tagline: 'Engenheiro. Criador. Operador.',
    persona_professional_blurb:
      'Para o homem que pensa em sistemas. Curioso, direto, sem hype.',
    persona_professional_cta: 'Vamos ao que interessa.',

    // Programs / pricing
    plansEyebrow: 'Programas',
    plansTitle: 'Três programas. Um combo.',
    plansSub:
      'Escolha o que faz sentido — disfunção erétil, testosterona ou GLP-1 para perda de peso. Ou leve o Total. Mensal. Cancele quando quiser.',
    planCadence: 'mês',
    planPerformanceName: 'Performance',
    planPerformanceTag: 'Disfunção Erétil',
    planPerformanceBody:
      'Genéricos aprovados pelo FDA para disfunção erétil. Consulta médica, receita e envio discreto inclusos.',
    planStrengthName: 'Strength',
    planStrengthTag: 'Testosterona',
    planStrengthBody:
      'Reposição de testosterona quando clinicamente indicada. Exames semestrais, consultas e medicação inclusos.',
    planResetName: 'Reset',
    planResetTag: 'GLP-1 Perda de Peso',
    planResetBody:
      'Semaglutida ou tirzepatida manipuladas para homens prontos para mudar. Consulta, ajuste de dose e envio inclusos.',
    planTotalName: 'Total',
    planTotalTag: 'Os Três',
    planTotalBody:
      'Performance + Strength + Reset juntos. Economize cerca de $160 por mês em vez de assinar separadamente.',
    plansFooter:
      'A assinatura cobre ligações ilimitadas com o Alfred. Consultas médicas e prescrições são feitas por médicos credenciados no seu estado e cobradas com preços justos e transparentes. Não aceitamos plano de saúde — muitos pacientes usam recibos de HSA ou FSA.'
  }
};

export function t(lang, key) {
  return (strings[lang] && strings[lang][key]) || strings.en[key] || key;
}
